import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { UtilityService } from './shared/utility.service';
import { ZipCodeResponse } from '../../models/contact-modal/zip.model';
import { delayedRetryHttp } from './shared/delayedRetry';

@Injectable({
  providedIn: 'root'
})
export class ZipService {

  private baseUrl: string;
    private api: string = "api/Engage/Zip";

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
    this.baseUrl = _baseUrl + this.api;
  }

  async zip_Get(encryptedUser: string, zip: any): Promise<ZipCodeResponse | void> {
    const a = await this.httpClient
      .get<ZipCodeResponse>(`${this.baseUrl}/Zip_Get/${zip}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + "," + "zip - " + zip, encryptedUser, "ZipService", "zip_Get"); });
    return a;
  }

}
